import {IStore} from '../interfaces/store';
import {Ecologies} from '../constants/ecologies';

/**
 * Whether the active view is an ecology view or not
 */
export default function(state: IStore): boolean {
  return Ecologies.has(state.view);
}
